import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
	static targets = ["editLink"]

	edit(event) {
		event.preventDefault()
		event.stopPropagation()
		const editUrl = this.editLinkTarget.getAttribute("href")
		window.location.replace(editUrl)
	}

	klik(event) {
		if (event.target.classList[0] == "calendar-session-popover-title") {
			event.stopPropagation()
			return
		}

		const deleteButton = event.target.closest(".delete-model-session")
		if (deleteButton) {
			return
		}

		const dayDiv = event.target.closest(".has-events")
		if (dayDiv) {
			const dayEvent = dayDiv.querySelector(".calendar-txt-content")
			if (dayEvent.offsetParent) {
				event.preventDefault()
				event.stopPropagation()
			}
		}
	}
}
